import React from 'react';
import { Autocomplete as RAutocomplete } from 'react-toolbox/lib/autocomplete';
import styles from 'components/Autocomplete.css';

const Autocomplete = props => <RAutocomplete theme={styles} {...props} />;

export default Autocomplete;
